import { useMediaQuery, useTheme } from '@mui/material';
import { Info } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

interface BeneficiariesHeadersProps {
  boldHeader?: boolean;
}

export const PrimaryBeneficiaryPlanCardDetails = ({
  // eslint-disable-next-line
  boldHeader,
}: BeneficiariesHeadersProps) => {
  const { t } = useTranslation('pages.enrollmentAddBeneficiaries');

  const theme = useTheme();
  const desktopViewConditions = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <>
      <h3 className="body1 semiBold">
        {t('primaryBeneficiariesTitle')}
        <span className="red" aria-hidden="true">
          *
        </span>
        <span className="sr-only">{t('common:required')}</span>
      </h3>
      {!desktopViewConditions && <hr />}
      {desktopViewConditions && (
        <p className="body2">{t('primaryBeneficiariesDescription')}</p>
      )}
    </>
  );
};

export const SecondaryBeneficiaryPlanCardDetails = ({
  // eslint-disable-next-line
  boldHeader,
}: BeneficiariesHeadersProps) => {
  const { t } = useTranslation('pages.enrollmentAddBeneficiaries');

  const theme = useTheme();
  const desktopViewConditions = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <>
      <h3 className="body1 semiBold">
        {desktopViewConditions
          ? t('secondaryBeneficiariesTitle')
          : t('secondaryBeneficiariesTitleForMobileView')}
        {!desktopViewConditions && <Info size={25} weight="fill" />}
      </h3>
      {!desktopViewConditions && <hr />}
      {desktopViewConditions && (
        <p className="body2">{t('secondaryBeneficiariesDescription')}</p>
      )}
    </>
  );
};
